module.exports = __webpack_public_path__ + "static/media/gold_badge.664a622c.png";